/** The hostnames of a development machine's own server. */
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

/**
 * Whether this is NOT the live system: the test installation on the NAS
 * (`dev.data.server.as-t.cloud`, see DEPLOYMENT.md) or a development machine.
 * Read off the hostname, not a build flag: the dev installation copies its
 * settings from live, and a forgotten flag would make it look exactly like the
 * real thing — with the real data in it.
 */
const hostname = window.location.hostname;
export const IS_TEST_ENVIRONMENT =
    hostname.startsWith('dev.') || LOCAL_HOSTNAMES.has(hostname);

/** The app name in the browser tab: "AST", or "AST TEST" off the live system. */
export const APP_TITLE = IS_TEST_ENVIRONMENT ? 'AST TEST' : 'AST';
